const NorthernCyprusSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112068)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.83865 6.95703C4.13686 7.77211 3.49975 8.64422 2.93506 9.5657H37.0641C36.4994 8.64422 35.8624 7.77203 35.1605 6.95703H4.83865Z"
        fill="#D80027"
      />
      <path
        d="M4.83857 33.0432H35.1605C35.8623 32.2282 36.4994 31.3561 37.0641 30.4346H2.93506C3.49967 31.356 4.13678 32.2282 4.83857 33.0432Z"
        fill="#D80027"
      />
      <path
        d="M17.4401 16.3428L19.0811 18.6041L21.7387 17.7424L20.0951 20.0018L21.7359 22.263L19.0793 21.398L17.4358 23.6574L17.4374 20.8636L14.7808 19.9986L17.4384 19.1368L17.4401 16.3428Z"
        fill="#D80027"
      />
      <path
        d="M12.9619 25.6517C9.84037 25.6517 7.30975 23.1211 7.30975 19.9995C7.30975 16.878 9.84037 14.3473 12.9619 14.3473C13.9352 14.3473 14.8511 14.5934 15.6506 15.0267C14.3963 13.8001 12.6809 13.043 10.788 13.043C6.946 13.043 3.83154 16.1575 3.83154 19.9995C3.83154 23.8414 6.94607 26.9559 10.788 26.9559C12.6809 26.9559 14.3963 26.1988 15.6506 24.9722C14.8511 25.4056 13.9353 25.6517 12.9619 25.6517Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112068">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NorthernCyprusSvg;
